import { CustomButtonPropsType } from "./types/customButton.types";

export default function CustomButton({
  type = "button",
  theme = "dark",
  loading = false,
  disabled = false,
  text,
  className = "",
  fullWidth = false,
  onClick,
  children,
  icon,
}: CustomButtonPropsType) {
  const baseStyles =
    "py-2 px-6 rounded-2xl text-[14px] flex items-center justify-center font-medium transition-all duration-300 relative overflow-hidden";

  // Elegant theme styles with subtle borders and smooth hover effects
  const themeStyles = {
    dark: "bg-primary text-primary-foreground border border-transparent hover:bg-primary/90 hover:shadow-md",
    light:
      "bg-white text-primary border border-primary hover:bg-primary/10 hover:shadow-md",
    red: "bg-white text-status-critical border border-status-critical hover:bg-status-critical-subtle hover:shadow-md",
    blue: "bg-primary text-primary-foreground border border-transparent hover:bg-primary/90 hover:shadow-md",
  };

  const disabledStyles =
    disabled || loading ? "opacity-70 cursor-not-allowed" : "cursor-pointer";

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={`
        ${baseStyles}
        ${themeStyles[theme]}
        ${fullWidth ? "w-full" : ""}
        ${disabledStyles}
        ${className}
      `}
    >
      {loading ? (
        <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
      ) : (
        <>
          {icon && <span className="flex items-center pr-2">{icon}</span>}
          {children || text}
        </>
      )}
    </button>
  );
}
